import React from "react";
import coverImage from "../../assets/images/cover.JPG";

const SocaFolder = ({ name, onClick, className }) => {
  return (
    <div className={className} onClick={onClick}>
      <img 
        src={coverImage} 
        alt={name} 
        style={{ 
          width: "64px", 
          height: "64px", 
          objectFit: "cover",
          borderRadius: "8px",
          cursor: "pointer"
        }} 
      />
      <div style={{ 
        textAlign: "center", 
        marginTop: "8px", 
        fontSize: "12px",
        fontWeight: "bold",
        color: "white",
        maxWidth: "80px",
        wordWrap: "break-word"
      }}>
        {name}
      </div>
    </div>
  );
};

export default SocaFolder;
